import React, { Component } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  withStyles,
  Button,
} from "@material-ui/core";
import fire from "../index.js";

const HeadingText = withStyles({
  root: {
    flexGrow: 1,
  },
})(Typography);

const LogoutButton = withStyles({
  root: {
    color: "white",
  },
})(Button);

class TopBar extends Component {
  state = {
    user: this.props.user,
  };

  render() {
    return (
      <AppBar position="static">
        <Toolbar>
          <HeadingText variant="h6">Participace21-MAP admin page</HeadingText>
          {this.renderLogoutButton()}
        </Toolbar>
      </AppBar>
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({ user: this.props.user });
    }
  }

  renderLogoutButton = () => {
    if (this.state.user) {
      return (
        <LogoutButton onClick={this.handleLogout}>
          logout {this.state.user.email}
        </LogoutButton>
      );
    }
  };

  handleLogout = () => {
    fire
      .auth()
      .signOut()
      .catch((error) => {
        console.log(error);
      });
  };
}

export default TopBar;
